import AbstractService from "./AbstractService";

export default class ContractRequestService extends AbstractService {
  url(url) {
    return `/contract${url}`;
  }

  findAll(query, include, embed, page, perPage, field, ascending) {
    const q = Object.assign({}, query);
    const params = this.getParams(
      q,
      include,
      embed,
      page,
      perPage,
      field,
      ascending
    );
    return this.http.get(this.url("/getAll"), {
      params
    });
  }

  createUnderEmployee(model) {
    return this.http.post(this.url("/Employee"), model);
  }

  findAllUnderCharge(reference, query, include, embed, page, perPage, field, ascending) {
    const q = Object.assign({}, query);
  
    const params = this.getParams(
      q,
      include,
      embed,
      page,
      perPage,
      field,
      ascending
    );
    return this.http.get(this.url(`/underCharge/${reference}`), {
      params
    });
  }

  confirmRequest(reference, body) {
    return this.http.post(this.url(`/answer/${reference}`), body);
  }

  postAdditionalInformation(reference, body) {
    return this.http.post(this.url(`/contract/additionalInformation/${reference}`), body);
  }

  generateContract(reference) {
    return this.http.get(this.url(`/answer/${reference}`), { responseType: 'blob' });
  }

  deleteRequest(reference) {
    return this.http.delete(this.url(`/query/${reference}`));
  }

  editRequest(reference, body) {
    return this.http.put(this.url(`/query/${reference}`), body);
  }

  requestExist(body) {
    return this.http.post(this.url('/contract/demandExist'), body);
  }

  findAllReqestsByEmail(email) {
    return this.http.get(this.url(`/contract/getAllByEmail/${email}`));
  }

  _modelToQuery(model) {
    const query = Object.assign({}, model);
    return query;
  }
}
